import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //存储用户token
    id:'',
    //存储用户姓名
    name:'',
    //存储购物车数量
    shopNum:0,
    //存储用户的唯一id
    userId:'',
    //存储shopId=>店家id，店家才有id，不是店家就undefined
    shopId:'',
	// 判断用shopid不知道上面那个变量哪里用过登录完了会置空
	newShopId:'',
    //存储店铺信息
    store:{
      id: '',
      name: '', 
      owner_id: '',
      state: '',
      is_project: '',
      platform_name: '',
      mechanism_name: '',
      region: '',
      is_invoice: '',
      agreement: '',
      is_cer: '',
      logo_header_file_name: '',
      logo_footer_file_name: '',
      customer2: '',
      customer: '',
      footer: '',
      alipay: '',
      wxpay: '',
      unionpay: '',
      oldUserData:{}
    },
    //存储辅导员的token
    instructor:'',
    // 存储权限管理员的token
    authority_management: ''
  },
  mutations: {
     
  },
  actions: {
    
  }
})
